// extracted by mini-css-extract-plugin
module.exports = {"items":"DragDropItems__items--1AX6Y-L26aXiCxIiDWrneu","isDraggingOver":"DragDropItems__isDraggingOver--3xnhHwVRW_XBCE-TbhOqdT"};